// extracted by mini-css-extract-plugin
module.exports = {"modal":"SlideImage_modal__1pxbN","galleryContainer":"SlideImage_galleryContainer__8Ovnk"};